import { render } from "./PhoneSelector.vue?vue&type=template&id=9df79fea&scoped=true"
import script from "./PhoneSelector.vue?vue&type=script&lang=js"
export * from "./PhoneSelector.vue?vue&type=script&lang=js"

import "./PhoneSelector.vue?vue&type=style&index=0&id=9df79fea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df79fea"]])

export default __exports__